export const MenuType = [
  { label: '꿀프소개', path: 'about' },
  { label: '꿀프장검색', path: 'golf' },
  { label: '꿀플루언서', path: 'youtube' },
  { label: '꿀투표', path: 'survey' },
  { label: '꿀소통', path: 'blog' },
  { label: '꿀문의', path: 'inquiry' },
  { label: '꿀정보', path: 'promotion' },
  { label: '꿀톡', path: 'community' },
  { label: '공지사항', path: 'notice' },
  { label: '목소리', path: 'feedback' },
]

export type MenuInfoData = {
  cmpnyCd: string
  menuPath: string
  menuPathSn: number
  code: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  infoSn?: number
  infoSj?: string
  infoCn?: string
  useYn: string
  delYn: string
  infoCnList?: string[]
}

export const successMessages = {
  insert: '저장되었어요.',
  update: '수정되었어요.',
  delete: '삭제되었어요.',
}

export const errorMessages = {
  insert: '저장에 실패했어요.',
  update: '수정에 실패했어요.',
  delete: '삭제에 실패했어요.',
}

export const confirmMessages = {
  insert: '저장할까요?',
  update: '수정할까요?',
  delete: '삭제할까요?',
  cancel: '취소하시겠어요?',
  updateCancel: '수정한 내용은 저장되지 않아요. 정말 취소하시겠어요?',
}

export const menuInfo = {
  title: ' 메뉴기본정보',
  updDate: '수정일시',
  detailTitle: ' 안내사항 제목',
  detailContents: ' 안내사항 내용',
}

export const TableHeaders = [
  'No.',
  '제목',
  '내용',
  '등록자',
  '등록일시',
  '사용여부',
  '삭제여부',
]

export const columnWidths = [
  '60px',
  '200px',
  '300px',
  '100px',
  '150px',
  '60px',
  '60px',
]
